import { InvalidCount } from 'components/common-form/hooks/invalid-fields/model';
import type { FC } from 'react';

import { CountBadge } from './CountBadge';

type InvalidFieldsCountProps = {
  value: InvalidCount;
  id: string;
  errorPrefix?: string;
};

export const InvalidFieldsCount: FC<InvalidFieldsCountProps> = ({
  id,
  value: { totalCount, severity, validations },
  errorPrefix,
}) => (
  <CountBadge
    id={`error-count-${id}`}
    count={totalCount}
    color={severity === 'error' ? 'warning' : 'info'}
    validations={validations}
    errorPrefix={errorPrefix}
  />
);
